import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Injector, NgZone, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {IPlayerService} from '../../interfaces/IPlayerService';
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";
import {DialogPopComponent} from "../dialog-pop/dialog-pop.component";
import {Log, LogTag} from "../../services/Log";


@Component({
    selector: 'app-signage-info',
    templateUrl: './signage-info.component.html',
    styleUrls: ['./signage-info.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignageInfoComponent implements OnInit {
  appType = 'Local';
  appVersion = 'NA';
  libVersion;
  extensionVersion;
  changeDetectorRef: ChangeDetectorRef;
  playerService: IPlayerService;
  unregister = 'unregister'

  constructor(
    private ngZone: NgZone,
    protected injector: Injector,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SignageInfoComponent>, @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit(): void {
    const logInfo = Log.getLogInfo("SignageInfoComponent", "ngOnInit", []);
    this.playerService = this.injector.get('playerService');
    this.changeDetectorRef = this.injector.get(ChangeDetectorRef);
    Log.i(logInfo, LogTag.INIT,'appType = ' + this.playerService.appType);
    this.appType          = "Release:     " + this.playerService.appType;
    this.appVersion       = "Application: " + this.playerService.appVersion
    this.libVersion       = "Library:     " + this.playerService.libVersion;
    this.extensionVersion = this.playerService.extensionVersion;
  }


  onDownloadWin32() {
    (<PlayerPwaService>this.playerService).downloadWin32();
  }

  onDownloadLinux() {
    (<PlayerPwaService>this.playerService).downloadLinux();
  }

  onDownloadAndroid() {
    (<PlayerPwaService>this.playerService).downloadAndroid();
  }

  onUnregister() {
    const dialogRef = this.dialog.open(DialogPopComponent, {
      height: '200px',
      width: '400px',
      data: {name: `Unregister?`, showCancel: true}
    });
    dialogRef.afterClosed().subscribe(r => {
      if (r != null) {
        (<PlayerPwaService>this.playerService).unregister();
        this.unregister = 'player removed';
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  onShowFPS() {
    this.playerService.showFps = true;
  }

  onReadLog() {
    (<PlayerPwaService>this.playerService).watchdog.readLog();
  }

  onClearLog() {
    (<PlayerPwaService>this.playerService).watchdog.clearLog();
  }

  onTestHung() {
    (<PlayerPwaService>this.playerService).watchdog.testHung();
    this.dialogRef.close();
  }

  onTestSlow() {
    (<PlayerPwaService>this.playerService).watchdog.testSlow();
    this.dialogRef.close();
  }

  onAbnormalExit() {
    (<PlayerPwaService>this.playerService).watchdog.testAbnormalExit();
    this.dialogRef.close();
  }

  onInfiniteMemLeak() {
    (<PlayerPwaService>this.playerService).watchdog.testInfiniteMemLeak();
    this.dialogRef.close();
  }

  onInfiniteDomLeak() {
    (<PlayerPwaService>this.playerService).watchdog.testInfiniteDomLeak();
    this.dialogRef.close();
  }

  onLoseContext() {
    const canvases = document.getElementsByTagName("canvas");
    if (canvases.length === 1) {
      const canvas = canvases[0];
      const webgl2 = canvas.getContext("webgl2", {});
      if (webgl2!=null) {
        webgl2.getExtension('WEBGL_lose_context').loseContext();
      } else {
        const webgl = canvas.getContext("webgl", {});
        if (webgl!=null) {
          webgl.getExtension('WEBGL_lose_context').loseContext();
        }
      }
    }
    this.dialogRef.close();
  }

  onClearErrors() {
    localStorage["errors"] = "[]";
  }

  onThrowErrorTest() {
    throw new Error("This is a Error test");
  }

  onShowErrors() {
    const errors = localStorage["errors"];
    if (errors==null) {
      alert("there is no errors");
    } else {
      alert(errors);
    }

  }

  onReboot() {
    (<PlayerPwaService>this.playerService).watchdog.reboot();
    this.dialogRef.close();
  }

  onTestAndroid() {
    /*
    const socket = new WebSocket("ws://192.168.0.117:38301");
    socket.onopen = function(e) {
      //alert("Connection established");
      socket.send('{command: "getName"}');
    };
    socket.onmessage = function(event) {
      let data = event.data
      alert(data);
    }
    socket.onerror = function(error) {
      alert('error=' + JSON.stringify(error));
    };

     */

    //document.location = "intent://com.sign.watchdog/test?id=12345#Intent;scheme=myapp;package=com.sign.watchdog;action=android.intent.action.SEND;end";
    //document.location = "intent://com.sign.watchdog/restartPlayer#Intent;scheme=signplayer;package=com.sign.watchdog;action=android.intent.action.SEND;end";
    //alert(window.navigator.userAgent);
    //window.location.reload();
    //navigator.serviceWorker.controller.postMessage({"msg": "ping"});
  }

  onClose() {
    //???this.ngZone.run(() => {
    this.dialogRef.close();
    //???});
  }
}
